import { Box } from '@material-ui/core';
import { formatMoney, Money } from '@nemuru-eng/js-api-client';
import React from 'react';

import { useCustomTheme } from '../../../../hooks/useCustomTheme';
import { StyledTooltip } from '../../../shared/components/StyledTooltip';
import { Font } from '../../../shared/components/Font';
import { Text } from '../../../shared/components/Text';
import { OrderLineInAction } from '../types/OrderLineInAction';

export function ActionExpandedDetails(props: {
  id: string;
  description: string | undefined;
  orderLineInActions: OrderLineInAction[];
  amount: Money;
}) {
  const { palette } = useCustomTheme();
  const rowStyle = {
    borderBottom: '1px solid',
    borderColor: palette.grey[200],
    paddingBlock: '10px',
  };

  return (
    <>
      <Box pt={2} width={'100%'}>
        <Font variant={'body2'}>Id:</Font> <Font variant={'caption'}>{props.id}</Font>
        {props.description && <Font variant={'body2'}>{props.description}</Font>}
        <Font variant={'body2'} color={'textSecondary'}>
          <Box display={'flex'} mt={2} style={rowStyle}>
            <Box flex={'1'}>
              <Text tId={'PRODUCT'} />
            </Box>
            <Box ml={2}>
              <Text tId={'AMOUNT'} />
            </Box>
          </Box>
        </Font>
        <Font variant={'body2'}>
          {props.orderLineInActions.map((orderLine) => (
            <StyledTooltip
              key={orderLine.id}
              title={orderLine.tooltip}
              tooltipProps={{ enterDelay: 300, placement: 'bottom-start' }}
            >
              <Box display={'flex'} style={rowStyle} className={'bg-only-on-hover'}>
                <>
                  <Box flex={'1'}>
                    {orderLine.name}
                    <br />
                    <Font variant={'caption'}>{orderLine.infoText}</Font>
                  </Box>
                  <Box ml={2}>{formatMoney(orderLine.amount)}</Box>
                </>
              </Box>
            </StyledTooltip>
          ))}
        </Font>
        <Font variant={'h5'}>
          <Box display={'flex'} style={{ paddingBlock: '10px' }}>
            <Box flex={'1'}>
              <Text tId={'TOTAL'} />
            </Box>
            <Box ml={2}>{formatMoney(props.amount)}</Box>
          </Box>
        </Font>
      </Box>
    </>
  );
}
